/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermosRouteImport } from './routes/termos'
import { Route as SucessoExclusaoRouteImport } from './routes/sucesso-exclusao'
import { Route as SucessoRouteImport } from './routes/sucesso'
import { Route as ResultadoRouteImport } from './routes/resultado'
import { Route as ProtocoloRouteImport } from './routes/protocolo'
import { Route as PagamentoRouteImport } from './routes/pagamento'
import { Route as ObjetivoRouteImport } from './routes/objetivo'
import { Route as EntrarRouteImport } from './routes/entrar'
import { Route as ContatoRouteImport } from './routes/contato'
import { Route as ContaRouteImport } from './routes/conta'
import { Route as ConsentimentoRouteImport } from './routes/consentimento'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as ChatRouteImport } from './routes/chat'
import { Route as CarregandoRouteImport } from './routes/carregando'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ContaConfiguracoesRouteImport } from './routes/conta.configuracoes'

const TermosRoute = TermosRouteImport.update({
  id: '/termos',
  path: '/termos',
  getParentRoute: () => rootRouteImport,
} as any)
const SucessoExclusaoRoute = SucessoExclusaoRouteImport.update({
  id: '/sucesso-exclusao',
  path: '/sucesso-exclusao',
  getParentRoute: () => rootRouteImport,
} as any)
const SucessoRoute = SucessoRouteImport.update({
  id: '/sucesso',
  path: '/sucesso',
  getParentRoute: () => rootRouteImport,
} as any)
const ResultadoRoute = ResultadoRouteImport.update({
  id: '/resultado',
  path: '/resultado',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtocoloRoute = ProtocoloRouteImport.update({
  id: '/protocolo',
  path: '/protocolo',
  getParentRoute: () => rootRouteImport,
} as any)
const PagamentoRoute = PagamentoRouteImport.update({
  id: '/pagamento',
  path: '/pagamento',
  getParentRoute: () => rootRouteImport,
} as any)
const ObjetivoRoute = ObjetivoRouteImport.update({
  id: '/objetivo',
  path: '/objetivo',
  getParentRoute: () => rootRouteImport,
} as any)
const EntrarRoute = EntrarRouteImport.update({
  id: '/entrar',
  path: '/entrar',
  getParentRoute: () => rootRouteImport,
} as any)
const ContatoRoute = ContatoRouteImport.update({
  id: '/contato',
  path: '/contato',
  getParentRoute: () => rootRouteImport,
} as any)
const ContaRoute = ContaRouteImport.update({
  id: '/conta',
  path: '/conta',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsentimentoRoute = ConsentimentoRouteImport.update({
  id: '/consentimento',
  path: '/consentimento',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => rootRouteImport,
} as any)
const CarregandoRoute = CarregandoRouteImport.update({
  id: '/carregando',
  path: '/carregando',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContaConfiguracoesRoute = ContaConfiguracoesRouteImport.update({
  id: '/configuracoes',
  path: '/configuracoes',
  getParentRoute: () => ContaRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/carregando': typeof CarregandoRoute
  '/chat': typeof ChatRoute
  '/checkout': typeof CheckoutRoute
  '/consentimento': typeof ConsentimentoRoute
  '/conta': typeof ContaRouteWithChildren
  '/contato': typeof ContatoRoute
  '/entrar': typeof EntrarRoute
  '/objetivo': typeof ObjetivoRoute
  '/pagamento': typeof PagamentoRoute
  '/protocolo': typeof ProtocoloRoute
  '/resultado': typeof ResultadoRoute
  '/sucesso': typeof SucessoRoute
  '/sucesso-exclusao': typeof SucessoExclusaoRoute
  '/termos': typeof TermosRoute
  '/conta/configuracoes': typeof ContaConfiguracoesRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/carregando': typeof CarregandoRoute
  '/chat': typeof ChatRoute
  '/checkout': typeof CheckoutRoute
  '/consentimento': typeof ConsentimentoRoute
  '/conta': typeof ContaRouteWithChildren
  '/contato': typeof ContatoRoute
  '/entrar': typeof EntrarRoute
  '/objetivo': typeof ObjetivoRoute
  '/pagamento': typeof PagamentoRoute
  '/protocolo': typeof ProtocoloRoute
  '/resultado': typeof ResultadoRoute
  '/sucesso': typeof SucessoRoute
  '/sucesso-exclusao': typeof SucessoExclusaoRoute
  '/termos': typeof TermosRoute
  '/conta/configuracoes': typeof ContaConfiguracoesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/carregando': typeof CarregandoRoute
  '/chat': typeof ChatRoute
  '/checkout': typeof CheckoutRoute
  '/consentimento': typeof ConsentimentoRoute
  '/conta': typeof ContaRouteWithChildren
  '/contato': typeof ContatoRoute
  '/entrar': typeof EntrarRoute
  '/objetivo': typeof ObjetivoRoute
  '/pagamento': typeof PagamentoRoute
  '/protocolo': typeof ProtocoloRoute
  '/resultado': typeof ResultadoRoute
  '/sucesso': typeof SucessoRoute
  '/sucesso-exclusao': typeof SucessoExclusaoRoute
  '/termos': typeof TermosRoute
  '/conta/configuracoes': typeof ContaConfiguracoesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/carregando'
    | '/chat'
    | '/checkout'
    | '/consentimento'
    | '/conta'
    | '/contato'
    | '/entrar'
    | '/objetivo'
    | '/pagamento'
    | '/protocolo'
    | '/resultado'
    | '/sucesso'
    | '/sucesso-exclusao'
    | '/termos'
    | '/conta/configuracoes'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/carregando'
    | '/chat'
    | '/checkout'
    | '/consentimento'
    | '/conta'
    | '/contato'
    | '/entrar'
    | '/objetivo'
    | '/pagamento'
    | '/protocolo'
    | '/resultado'
    | '/sucesso'
    | '/sucesso-exclusao'
    | '/termos'
    | '/conta/configuracoes'
  id:
    | '__root__'
    | '/'
    | '/carregando'
    | '/chat'
    | '/checkout'
    | '/consentimento'
    | '/conta'
    | '/contato'
    | '/entrar'
    | '/objetivo'
    | '/pagamento'
    | '/protocolo'
    | '/resultado'
    | '/sucesso'
    | '/sucesso-exclusao'
    | '/termos'
    | '/conta/configuracoes'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CarregandoRoute: typeof CarregandoRoute
  ChatRoute: typeof ChatRoute
  CheckoutRoute: typeof CheckoutRoute
  ConsentimentoRoute: typeof ConsentimentoRoute
  ContaRoute: typeof ContaRouteWithChildren
  ContatoRoute: typeof ContatoRoute
  EntrarRoute: typeof EntrarRoute
  ObjetivoRoute: typeof ObjetivoRoute
  PagamentoRoute: typeof PagamentoRoute
  ProtocoloRoute: typeof ProtocoloRoute
  ResultadoRoute: typeof ResultadoRoute
  SucessoRoute: typeof SucessoRoute
  SucessoExclusaoRoute: typeof SucessoExclusaoRoute
  TermosRoute: typeof TermosRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/termos': {
      id: '/termos'
      path: '/termos'
      fullPath: '/termos'
      preLoaderRoute: typeof TermosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sucesso-exclusao': {
      id: '/sucesso-exclusao'
      path: '/sucesso-exclusao'
      fullPath: '/sucesso-exclusao'
      preLoaderRoute: typeof SucessoExclusaoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sucesso': {
      id: '/sucesso'
      path: '/sucesso'
      fullPath: '/sucesso'
      preLoaderRoute: typeof SucessoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resultado': {
      id: '/resultado'
      path: '/resultado'
      fullPath: '/resultado'
      preLoaderRoute: typeof ResultadoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/protocolo': {
      id: '/protocolo'
      path: '/protocolo'
      fullPath: '/protocolo'
      preLoaderRoute: typeof ProtocoloRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pagamento': {
      id: '/pagamento'
      path: '/pagamento'
      fullPath: '/pagamento'
      preLoaderRoute: typeof PagamentoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/objetivo': {
      id: '/objetivo'
      path: '/objetivo'
      fullPath: '/objetivo'
      preLoaderRoute: typeof ObjetivoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entrar': {
      id: '/entrar'
      path: '/entrar'
      fullPath: '/entrar'
      preLoaderRoute: typeof EntrarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contato': {
      id: '/contato'
      path: '/contato'
      fullPath: '/contato'
      preLoaderRoute: typeof ContatoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conta': {
      id: '/conta'
      path: '/conta'
      fullPath: '/conta'
      preLoaderRoute: typeof ContaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/consentimento': {
      id: '/consentimento'
      path: '/consentimento'
      fullPath: '/consentimento'
      preLoaderRoute: typeof ConsentimentoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat': {
      id: '/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/carregando': {
      id: '/carregando'
      path: '/carregando'
      fullPath: '/carregando'
      preLoaderRoute: typeof CarregandoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conta/configuracoes': {
      id: '/conta/configuracoes'
      path: '/configuracoes'
      fullPath: '/conta/configuracoes'
      preLoaderRoute: typeof ContaConfiguracoesRouteImport
      parentRoute: typeof ContaRoute
    }
  }
}

interface ContaRouteChildren {
  ContaConfiguracoesRoute: typeof ContaConfiguracoesRoute
}

const ContaRouteChildren: ContaRouteChildren = {
  ContaConfiguracoesRoute: ContaConfiguracoesRoute,
}

const ContaRouteWithChildren = ContaRoute._addFileChildren(ContaRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CarregandoRoute: CarregandoRoute,
  ChatRoute: ChatRoute,
  CheckoutRoute: CheckoutRoute,
  ConsentimentoRoute: ConsentimentoRoute,
  ContaRoute: ContaRouteWithChildren,
  ContatoRoute: ContatoRoute,
  EntrarRoute: EntrarRoute,
  ObjetivoRoute: ObjetivoRoute,
  PagamentoRoute: PagamentoRoute,
  ProtocoloRoute: ProtocoloRoute,
  ResultadoRoute: ResultadoRoute,
  SucessoRoute: SucessoRoute,
  SucessoExclusaoRoute: SucessoExclusaoRoute,
  TermosRoute: TermosRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
